import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import type { Game, GameTypeName } from '../../types/Game';

import TileList from './TileList';
import { TXTCLI_Featured_games, TXTCLI_Regular_16 } from './TilesContainer.messages.json';
import styles from './TilesContainer.scss';

export interface TilesContainerProps {
  tiles: Game[];
  gameType: GameTypeName;
  selectedId: number;
  onGameSelect: (game: Game) => void;
}

const TilesContainer: React.FC<TilesContainerProps> = ({
  tiles,
  gameType,
  selectedId,
  onGameSelect
}) => {
  const isDesktopEmbedded = useSelector(select.device.isDesktopEmbedded);
  const promoTiles: Game[] = [];
  const regularTiles: Game[] = [];

  tiles.forEach((tile) =>
    tile.promoRef && !tile.isUltra ? promoTiles.push(tile) : regularTiles.push(tile)
  );

  return (
    <div className={isDesktopEmbedded ? styles.embeddedContent : styles.content}>
      {!!promoTiles.length && (
        <>
          <div className={styles.tilesHeader}>
            <Translation {...TXTCLI_Featured_games} />
          </div>
          <div
            className={classNames(styles.tilesContainer, styles.tilesPromo)}
            data-testid={`${gameType}-promo-tiles`}
          >
            <TileList
              tiles={promoTiles}
              showOnboarding={true}
              selectedId={selectedId}
              onGameSelect={onGameSelect}
              gameType={gameType}
            />
          </div>
          <div className={styles.tilesHeader}>
            <Translation {...TXTCLI_Regular_16} />
          </div>
        </>
      )}
      <div
        className={styles.tilesContainer}
        data-testid={`${gameType}-regular-tiles`}
        key={`${gameType}-tiles`}
      >
        {!!regularTiles.length && (
          <TileList
            tiles={regularTiles}
            showOnboarding={!promoTiles.length}
            selectedId={selectedId}
            onGameSelect={onGameSelect}
            gameType={gameType}
          />
        )}
      </div>
    </div>
  );
};

export default TilesContainer;
